<div class="prompt" role="note" aria-label="Assistant prompt">
  <div class="prompt-body">
    <div class="prompt-text">{{ payload.text }}</div>

    <div class="prompt-options" role="group" aria-label="Select an option">
      @for (opt of payload.options; track $index) {
        <button
          type="button"
          class="option"
          [class.selected]="selectedOptionId === opt.id"
          [attr.aria-pressed]="selectedOptionId === opt.id"
          [disabled]="disabled || hasSent"
          (click)="selectOption(opt.id)"
        >
          <span class="option-letter" aria-hidden="true">{{ optionLetter($index) }}</span>
          <span class="option-text">{{ opt.text }}</span>
        </button>
      }

      @if (payload.allow_freeform) {
        <div class="other-row" aria-label="Other answer">
          <input
            type="text"
            class="other-input"
            [ngModel]="otherText"
            (ngModelChange)="onOtherTextChange($event)"
            (focus)="onOtherFocus()"
            [disabled]="disabled || hasSent"
            placeholder="Other"
            aria-label="Other"
          />
        </div>
      }
    </div>

    <div class="prompt-actions">
      <button
        mat-flat-button
        type="button"
        class="submit"
        [disabled]="disabled || hasSent || (!selectedOptionId && (!payload.allow_freeform || !otherText.trim()))"
        (click)="submit()"
      >
        Submit
      </button>
    </div>
  </div>
</div>

